











































import Vue from "vue";
import ModalCreateNewReport from "@/components/organisms/modal/ModalCreateNewReport/index.vue";
import ModalUpdateNewReport from "@/components/organisms/modal/ModalUpdateReport/index.vue";
import { ModalProgrammatic } from "buefy/dist/components/modal";
import { Report } from "@/types/entities.ts";

export default Vue.extend({
  name: "app-sidebar",
  data() {
    return {
      active: "",
      isActive: false,
    };
  },
  props: {
    getMenu: Function,
    classname: String,
  },
  mounted() {
    this.active = this.$route.path;
    this.getMenu();
  },
  methods: {
    openCreateNewReporModal() {
      ModalProgrammatic.open({
        parent: this,
        component: ModalCreateNewReport,
        hasModalCard: true,
        props: {
          reportName: name,
        },
      });
    },
    openUpdateReportModal(item: Report) {
      ModalProgrammatic.open({
        parent: this,
        component: ModalUpdateNewReport,
        hasModalCard: true,
        props: {
          reportId: item.report_id,
          reportName: item.report_name,
          apiToken: item.token,
        },
      });
    },
  },
  watch: {
    $route(newPath) {
      this.active = newPath.fullPath;
    },
  },
});
